import styled from 'styled-components';
import Button from '../../../../../../../components/Atoms/Button/Button';
import Text from '../../../../../../../components/Atoms/Text/Text';
import { Gray } from '../../../../../../constants/styles';
import { ListItemLink, Popup } from '../../styled/Popup.styled';
export const StyledCartPopup = styled(Popup) `
  width: 280px;
`;
export const CartItem = styled.div `
  border-bottom: 1px solid ${({ theme }) => theme.colorsV2.ui.border.primary};
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 15px;
  padding-bottom: 15px;

  &:last-of-type {
    margin-bottom: 15px;
  }
`;
const getImageStyleBasedOnProduct = (isMagnet, shadow) => {
    if (isMagnet) {
        return `
    max-width: 100%;
    max-height: 100%;
  `;
    }
    return `
  border-radius: 2%;
  outline: 2px solid rgba(255,255,255,.25);
  outline-offset: -2px;
  box-shadow: 2px 2px 15px rgb(0 0 0 / 25%);
  box-shadow: ${shadow};
  `;
};
export const CartImage = styled.div `
  flex-basis: 39.75%;
  width: 100px;
  height: 100px;
  position: relative;
  background-color: ${({ theme }) => theme.colorsV2.ui.background.secondary};

  img {
    max-width: 80%;
    max-height: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    ${({ isMagnet, theme }) => getImageStyleBasedOnProduct(isMagnet, theme.shadows.small)}
  }
`;
export const CartItemDescription = styled.div `
  width: 56%;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  word-break: normal;
  position: relative;

  span {
    display: inline-block;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    max-height: 44px;
  }
`;
export const CartItemDetails = styled.div `
  display: flex;
  flex-wrap: wrap;
  flex-basis: 100%;
  justify-content: space-between;
`;
export const CartRow = styled.div `
  display: flex;
  flex-wrap: wrap;
  flex-basis: 100%;
  justify-content: flex-start;
`;
export const Price = styled.div `
  position: absolute;
  right: 6%;
  bottom: -2px;
`;
export const TextPrice = styled(Text) `
  text-decoration: ${({ isDiscounted }) => (isDiscounted ? 'line-through' : 'none')};
`;
export const ShowMore = styled.div `
  border-bottom: 1px solid ${Gray.x200};
  max-height: 38px;
  margin-top: -15px;
  padding-bottom: 7px;
  padding-top: 7px;
  margin-bottom: 15px;
`;
export const StyledButton = styled(Button) `
  width: 100%;
`;
export const StyledLink = styled(ListItemLink) `
  padding: 0;

  &:hover {
    text-decoration: none;
  }
`;
export const StyledShowMoreLink = styled(StyledLink) `
  display: block;
  color: ${({ theme }) => theme.colorsV2.ui.general.primary};
  text-align: center;
  font-weight: 600;
  &:visited,
  &:active,
  &:focus {
    color: ${({ theme }) => theme.colorsV2.ui.general.primary};
  }
`;
//# sourceMappingURL=CartPopup.styled.js.map